import { useState } from "react";
import { ReactComponent as TaskCompleteIcon } from "../../../static/svgs/TaskCompleteIcon.svg";
import { ReactComponent as TaskInprogressIcon } from "../../../static/svgs/TaskInprogressIcon.svg";
import { ReactComponent as TaskNotstartedIcon } from "../../../static/svgs/TaskNotstartedIcon.svg";
import Box from "@mui/material/Box";
import { Tooltip, TooltipProps, styled, tooltipClasses } from "@mui/material";

const CustomTask = ({
  activities,
  status,
}: any) => {
  const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: 'rgba(0, 82, 210, 1)',
      marginbottom: '2px'
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: 'rgba(0, 82, 210, 1)',
      color: 'rgba(255, 255, 255, 1)',
      borderRadius: "6px",
      fontFamily: "Open Sans",
      fontSize: "13px",
      width: 'auto',
      height: '34px',
      fontWeight: "600",
      lineHeight: "22px",
      textAlign: 'center'
    },
  }));
  const mergedActivities = activities.map((activity: any) => {
    const progressActivity = status?.activities.find(
      (pa: any) => pa.id === activity.activityId
    );
    return {
      ...activity,
      status: progressActivity?.status || "NOT_STARTED",
      responseSubmitted: progressActivity?.responseSubmitted || false,
    };
  });

  let [activeStep, setActiveStep] = useState(0);

  activeStep = mergedActivities.findIndex(
    (activity: any) => activity.status === "IN_PROGRESS"
  );

  const isAllCompleted = status?.status === "COMPLETED";

  const getStepIcon = (state: any, responseState: boolean) => {
    if (state == "COMPLETED") {
      return <TaskCompleteIcon />
    }
    if (responseState == true) {
      return <TaskCompleteIcon />
    }
    else if (state === "IN_PROGRESS" && responseState) {
      return <TaskCompleteIcon />
    }
    else if (state === "IN_PROGRESS") {
      return <TaskInprogressIcon />
    }
    else {
      return <TaskNotstartedIcon />
    }
  }

  return (<>

    {mergedActivities.map((activity: any, index: number) => (
       <BootstrapTooltip placement='top-start'
       title={activity.name}>
      <Box sx={{ display: 'flex', gap: '8px' }}>
        {getStepIcon(activity.status, activity.responseSubmitted)}
      </Box>
      </BootstrapTooltip>
    ))}

  </>)
}

export default CustomTask;